import * as s from "../../LoginStyled";
import { UnderlineText } from "components/atoms/text/Text";
import { COLORS } from "styles/colors";
import { Validate, ValidateMsg } from "api/interfaces/commonInterface.interface";
import {
  LOGIN_STEP,
  LoginInfo,
} from "../../LoginContainer";
import InputPassword from "../email/InputPassword";
import InputEmailForm from "../email/InputEmailForm";

interface Props {
  onChangeStep: (step: LOGIN_STEP) => void;
  loginInfo: LoginInfo;
  isValidated: Validate;
  validateMsg: ValidateMsg;
  onChangeLoginInfo: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onClickRegisterPasskey: () => void;
  step: LOGIN_STEP;
}

export const RegisterPasskey = (props: Props) => {
  return (
    <s.PassKeyBox>
      <s.LoginInfo>
        <h3>Setup Passkey</h3>
        <p className="description">
          Enter your email and password to register passkey.
        </p>
      </s.LoginInfo>

      <InputEmailForm
        loginInfo={props.loginInfo}
        isValidated={props.isValidated}
        validateMsg={props.validateMsg}
        onChangeLoginInfo={props.onChangeLoginInfo}
      />

      <InputPassword
        step={props.step}
        loginInfo={props.loginInfo}
        isValidated={props.isValidated}
        validateMsg={props.validateMsg}
        onChangeLoginInfo={props.onChangeLoginInfo}
        onChangeStep={props.onChangeStep}
        handleClick={props.onClickRegisterPasskey}
        autoFocus={false}
      />

      <s.Bottom center>
        <UnderlineText
          id="dw_login_button_forward_email"
          fontSize={14}
          color={COLORS.BUTTONS1}
          onClick={() => props.onChangeStep(LOGIN_STEP.LOGIN_WITH_PASSKEY)}
          data-testid="auth-signin-passkey-forward-email-change-step"
        >
          Go Back
        </UnderlineText>
      </s.Bottom>
    </s.PassKeyBox>
  );
};
